export const environment = {
  API_URL:'https://vt.apps.stefanini.io/api',
    AZURE_URL: 'https://corporativo-api.apps.stefanini.io/azure',
    AZURE_REDIRECT: 'https://ads-stflabs-corporativo-frontend-web.apps.stefanini.io/login/',
    AZURE_PROJECT: 'VT',
    AZURE_ENVIRONMENT: 'P',
    defaultDebounceTime: 500,
    production: true,
};